import { Component, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn
} from '@angular/forms';
import { ParentItemProviderService } from '@app/shared';
import { NtapCommonComponent } from '@ntap/core';
import { tap } from 'rxjs';

@Component({
  selector: 'app-restauracija',
  templateUrl: './restauracija.component.html',
  providers: [ParentItemProviderService]
})
export class RestauracijaComponent
  extends NtapCommonComponent
  implements OnInit
{
  @ViewChild('itemView', { static: true }) itemView: any;

  ngOnInit(): void {
    this.addSubscription(
      this.itemView.dynamicFormService.formGroup$
        .pipe(
          tap((fg: FormGroup) => {
            fg.addValidators(dateRangeValidator());
            fg.updateValueAndValidity();
          })
        )
        .subscribe()
    );
  }
}

function dateRangeValidator(): ValidatorFn {
  return (form: AbstractControl): ValidationErrors | null => {
    const startDate: Date = form.get(
      'earhiv~plan_restauratorskih_radova~vrijeme_pocetka'
    )?.value;
    const endDate: Date = form.get(
      'earhiv~plan_restauratorskih_radova~vrijeme_zavrsetka'
    )?.value;

    if (
      startDate &&
      endDate &&
      startDate instanceof Date &&
      endDate instanceof Date
    ) {
      const isDateRangeValid = endDate.getTime() - startDate.getTime() > 0;

      return isDateRangeValid ? null : { dateRange: true };
    }

    return null;
  };
}
